<!--
Copyright 2022 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
-->

<div class="app-home-container">
  @if (!hideTopbar) {
  <app-topbar [title]="titleText" [topbarView]="TopbarView.GALLERY_HOME" [imageFilePath]="topbarImage"
    (urlNavigate)="topBarNavigate($event)"></app-topbar>
  }

  @if (!permissions) {
  <span>
    <mat-card appearance="outlined">
      <mat-card-header>
        <mat-card-title>Initializing Data</mat-card-title>
        <mat-card-subtitle>Please wait ...</mat-card-subtitle>
      </mat-card-header>
      <mat-progress-spinner color="primary" mode="indeterminate">
      </mat-progress-spinner>
    </mat-card>
  </span>
  }
  @if (permissions) {
  <div class="main-area">
    <!-- Exhibits Container -->
    @if (!exhibitId) {
    <div class="top-row">
      <div class="one-cell last-cell">
        @if (canViewAdministration) {
        <button mat-icon-button (click)="gotoAdmin()" style="outline: none;" title="Administration">
          <mat-icon class="mdi-24px center-self" fontIcon="mdi-cog"></mat-icon>
        </button>
        }
      </div>
    </div>

    <div class="elevate list-container">
      <div class="icon-text-container">
        <mat-icon class="crucible-icon-gallery" svgIcon="crucible-icon-gallery"></mat-icon>
        <span class="exhibit-title text">My Exhibits</span>
        <div class="searchBox">
          <!-- Search Bar -->
          <mat-form-field style="width: 320px">
            <input matInput [(ngModel)]="filterString" (keyup)="applyFilter($event.target.value)"
              (input)="onFilterChange()" placeholder="Search">
            @if (filterString !== '') {
            <button mat-icon-button matSuffix (click)="clearFilter()" title="Clear Search">
              <mat-icon style="transform: scale(0.85)" fontIcon="mdi-close-circle-outline"></mat-icon>
            </button>
            }
          </mat-form-field>
        </div>
      </div>
      <div class="background text" autosize>
        <mat-table class="width-100 mat-table" [dataSource]="exhibitList" matSort>
          <!-- Name Column -->
          <ng-container matColumnDef="name">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Name</mat-header-cell>
            <mat-cell *matCellDef="let exhibit">
              <a [routerLink]="['/']" [queryParams]="{ exhibit: exhibit.id, section: Section.archive }">
                {{ exhibit.name }}
              </a>
            </mat-cell>
          </ng-container>
          <!-- Description Column -->
          <ng-container matColumnDef="description">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Description</mat-header-cell>
            <mat-cell *matCellDef="let exhibit">{{ exhibit.description }}</mat-cell>
          </ng-container>
          <!-- Collection Column -->
          <ng-container matColumnDef="collection">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Collection</mat-header-cell>
            <mat-cell *matCellDef="let exhibit">{{ getCollectionName(exhibit.collectionId) }}</mat-cell>
          </ng-container>
          <!-- Date Created Column -->
          <ng-container matColumnDef="dateCreated">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Created</mat-header-cell>
            <mat-cell *matCellDef="let exhibit">{{ exhibit.dateCreated | date:"yyyy-MM-dd HH:mm" }}</mat-cell>
          </ng-container>
          <mat-header-row
            *matHeaderRowDef="['name', 'description', 'collection', 'dateCreated']; sticky: true"></mat-header-row>
          <mat-row *matRowDef="let exhibit; columns: ['name', 'description', 'collection', 'dateCreated']"></mat-row>
        </mat-table>
        <!-- Filter No Results Found -->
        @if (exhibitList.data.length === 0) {
        <div class="text no-results">
          No results found
        </div>
        }
        <mat-paginator [pageSizeOptions]="[10, 25, 50, 100]" showFirstLastButtons aria-label="Select page of exhibits">
        </mat-paginator>
      </div>
    </div>
    }
    @if (exhibitId && selectedSection === 'wall') {
    <app-wall [showAdminButton]="canViewAdministration" [showAdvanceButton]="canManageCurrentExhibit"
      [exhibit]="exhibit" (changeTeam)="changeTeam($event)" (sectionSelected)="gotoSection($event)"></app-wall>
    }
    @if (exhibitId && selectedSection === 'archive') {
    <app-archive [showAdminButton]="canViewAdministration" (changeTeam)="changeTeam($event)"
      (sectionSelected)="gotoSection($event)"></app-archive>
    }
  </div>
  }
</div>
